import script from "./DefaultLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&setup=true&lang=js"

import "./DefaultLayout.vue?vue&type=style&index=0&id=e5bcb1ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5bcb1ac"]])

export default __exports__